document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-routine-slider]").forEach((slider) => {
    const track = slider.querySelector("[data-routine-track]");
    if (!track) return;

    const cards = Array.from(track.querySelectorAll("[data-routine-card]"));
    if (!cards.length) return;

    const isDesktop = window.matchMedia("(min-width: 768px)");

    const setActiveCard = (activeCard, shouldScroll = false) => {
      cards.forEach((card) => {
        card.classList.toggle("is-active", card === activeCard);
      });

      if (shouldScroll) {
        activeCard.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    };

    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        if (!isDesktop.matches) return;
        setActiveCard(card, false);
      });

      card.addEventListener("click", () => {
        setActiveCard(card, !isDesktop.matches);
      });
    });
  });
});
